import { createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-route-wrapper" }
const _hoisted_2 = { class: "b-main-panel-wrapper" }
const _hoisted_3 = { class: "h-pos-rel container h-width-100p" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FixedBackground = _resolveComponent("FixedBackground")!
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_GoBackButton = _resolveComponent("GoBackButton")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { id: "popupWrapper" }, null, -1))
    ])),
    _createVNode(_component_FixedBackground),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showAppHeader)
        ? (_openBlock(), _createBlock(_component_AppHeader, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.showBackButton)
          ? (_openBlock(), _createBlock(_component_GoBackButton, {
              key: 0,
              class: "b-route-wrapper__back_arrow"
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_router_view)
    ])
  ]))
}